var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVerifiedVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.4,410.6L294,508.9l-3.9-20c-9.1-24.5-28.8-50.2-51.7-60.7l33.4,126.3l39.5,0l58.7-144.1H330.4 L330.4,410.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "361.7,554.8 385,410.4 422.3,410.4 399,554.8 361.7,554.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534.2,414c-7.4-2.9-19-6.1-33.4-6.1c-36.9,0-62.8,19.6-63,47.6c-0.2,20.8,18.5,32.3,32.6,39.2 c14.6,7.1,19.4,11.6,19.4,17.9c-0.1,9.7-11.6,14.1-22.3,14.1c-14.9,0-22.8-2.2-35.1-7.5l-4.8-2.3l-5.2,32.3 c8.7,4,24.8,7.5,41.6,7.7c39.1,0,64.6-19.4,64.9-49.3c0.2-16.5-9.8-28.9-31.3-39.2c-13-6.7-21-11.1-20.9-17.9 c0-6,6.7-12.4,21.4-12.4c12.2-0.2,21,2.6,27.9,5.6l3.3,1.7L534.2,414L534.2,414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M629.8,410.6H601c-8.9,0-15.6,2.5-19.6,12l-55.3,132.3h39.1c0,0,6.4-17.8,7.9-21.7c4.3,0,42.3,0.1,47.7,0.1 c1.2,5,4.5,21.6,4.5,21.6H660L629.8,410.6L629.8,410.6z M583.8,503.6c3.1-8.3,14.8-40.4,14.8-40.4c-0.2,0.4,3.1-8.3,5-13.8 l2.5,12.4c0,0,7.2,34.5,8.7,41.7C609,503.6,591.1,503.6,583.8,503.6L583.8,503.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.1,410.5H200l-0.4,2.5c46.7,12,77.6,41.3,90.4,76L277,422.6C274.8,413.5,268.2,410.8,260.1,410.5 L260.1,410.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "87.2,375.6 63.5,375.6 36,252 62.3,247.6 81.1,344.3 128.9,248.9 154.1,248.9 87.2,375.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.9,335.2h-56.7c-1.6,17.2,6.4,24.7,20,24.7c11.3,0,21.3-4.2,32-11l-0.1,17.2c-10.5,6.6-22.7,10.8-37,10.8 c-24.7,0-41-14.1-36.1-45.9c4.4-28.7,24.3-46.1,47.3-46.1c26.5,0,35.3,19.9,31.5,45C211.6,331.7,211,333.9,210.9,335.2L210.9,335.2 z M177.5,300.1c-8.8,0-17,6.9-20.8,21.4h35.1C192.4,307.8,188.1,300.1,177.5,300.1L177.5,300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.8,324.4L240,375h-21.9l13.6-88.3h18.7l0,17.7c7.4-10.2,17.5-18.8,31.4-19.6l0.1,21.8 C267.9,307.6,255.5,314.9,247.8,324.4L247.8,324.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.5,375l13.6-88.3H317L303.5,375H281.5L281.5,375z M308.5,271.9c-7.3,0-12.4-5.1-11.2-12.4 c1.2-7.5,7.8-12.8,15.1-12.8c7.1,0,12.2,5.3,11,12.8C322.3,266.8,315.7,271.9,308.5,271.9L308.5,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377.8,262.6c-7.5,0-12,3.3-13.2,11.2l-2,13h16.8l0,17.9h-19.6L349,375h-21.8l10.8-70.4h-12.8l2.8-17.9h12.8 l2.3-15.2c3-19.6,16.6-26.9,34.7-26.9c3.8,0,6.7,0.4,8.9,0.7l0.2,17.9C384.7,263,381.5,262.6,377.8,262.6L377.8,262.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378,375l13.6-88.3h21.9L400,375H378L378,375z M405.1,271.9c-7.3,0-12.4-5.1-11.3-12.4 c1.2-7.5,7.8-12.8,15.1-12.8c7.1,0,12.2,5.3,11,12.8C418.8,266.8,412.2,271.9,405.1,271.9L405.1,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.7,335.2H442c-1.5,17.2,6.4,24.7,20,24.7c11.3,0,21.3-4.2,32-11l-0.1,17.2c-10.5,6.6-22.7,10.8-37,10.8 c-24.7,0-41-14.1-36.1-45.9c4.4-28.7,24.3-46.1,47.3-46.1c26.5,0,35.3,19.9,31.5,45C499.4,331.7,498.8,333.9,498.7,335.2 L498.7,335.2z M465.3,300.1c-8.8,0-17,6.9-20.8,21.4h35.1C480.2,307.8,475.9,300.1,465.3,300.1L465.3,300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M563.6,375l0.1-12.3c-7.4,7.5-17,14.1-29.2,14.1c-18.5,0-31.2-13.7-26.6-43.5c5.1-32.9,25.4-47.5,45.9-47.5 c8.4,0,15,1.5,20,3.3l6.6-42.6l22.5-3.5l-20.3,132H563.6L563.6,375z M571,307.2c-5.1-2.6-9.1-3.8-16.6-3.8 c-11.5,0-21.4,9.3-24.3,28.7c-2.6,17.2,3.4,25.2,13.1,25.2c8,0,15-4.8,22-12.1L571,307.2L571,307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M649.7,375.9c-10.4,0-18.9-1.7-26.7-4.4l14.4-93.8l17-2.6l-6.2,40.6c5-4.4,11.9-8.9,20.3-8.9 c14.1,0,23.6,10.5,20.1,33C684.8,364.4,669.6,375.9,649.7,375.9L649.7,375.9z M662,321.4c-5.5,0-11.1,3.7-16,8.7l-4.7,30.3 c3.3,1.2,5.5,1.8,10.2,1.8c10.5,0,17.9-6.4,20.2-21.6C673.7,327.8,669.4,321.4,662,321.4L662,321.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M727.8,378.7c-8.5,16.5-16.9,21.6-29.8,21.6c-2.9,0-4.5-0.3-6-0.7l-0.1-13.7c2.1,0.6,4.4,1,7.6,1 c4.8,0,9.1-2.2,11.9-7.1l2.2-4.4l-14.1-65.9l17.7-2.2l8.2,47.6l22.1-46.7H764L727.8,378.7L727.8,378.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVerifiedVisa);
export default __webpack_public_path__ + "static/media/logo_verified_visa.62ddec04d990a1fa46f2035f78a74054.svg";
export { ForwardRef as ReactComponent };